import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-encounter-billing',
  standalone: true,
  imports: [],
  templateUrl: './encounter-billing.component.html',
  styleUrl: './encounter-billing.component.scss'
})
export class EncounterBillingComponent implements OnInit
{

  constructor(private _store: Store, private _route: ActivatedRoute) 
  { 
    
  }

  encounterId?: number;


  ngOnInit(): void 
  {
    this._route.paramMap.subscribe
    (
      p => 
        {
          const eId = p.get("encounterId")
          if(eId)
            // this._store.dispatch(new Encounters.EncounterSelected({encounterId: Number.parseInt(eId) }))
            this.encounterId = parseInt(eId);
        }
    );  
  }

}
